import dayjs from "@gtmhub/dayjs";
import { CurrentUserService } from "@gtmhub/users";
import { CheckInMetadataEntry, ICheckInsNewLabelMetadataEntry } from "@gtmhub/users/models";
import { checkInsMetadata, checkInsNewLabelOld } from "../components/checkins-new-label/checkins-new-label.component";

export const isCheckInsNewLabelVisible = ({
  areCheckInsEnabled,
  currentUserService,
}: {
  areCheckInsEnabled: boolean;
  currentUserService: CurrentUserService;
}): boolean => {
  if (!areCheckInsEnabled) return false;

  let newLabelFromStorage = currentUserService.getUserSetting<CheckInMetadataEntry>(checkInsMetadata);
  const newLabelFromStorageOld = currentUserService.getUserSetting<ICheckInsNewLabelMetadataEntry>(checkInsNewLabelOld);
  if (!newLabelFromStorage) {
    const newLabelInitialState = { [checkInsMetadata]: { newLabel: { firstSeenAt: dayjs().utc().toISOString(), userHasPosted: false } } };
    if (newLabelFromStorageOld) {
      newLabelInitialState[checkInsMetadata].newLabel.firstSeenAt = newLabelFromStorageOld.firstWatchedDate;
      newLabelInitialState[checkInsMetadata].newLabel.userHasPosted = newLabelFromStorageOld.userHasPublishedCheckin;
    }
    currentUserService.setUserSetting(newLabelInitialState);
    newLabelFromStorage = newLabelInitialState[checkInsMetadata];
  }
  const isfirstSeenAtInLastMonth = dayjs().diff(newLabelFromStorage.newLabel.firstSeenAt, "days") <= 30;
  const hasCheckInBeenPublished = newLabelFromStorage.newLabel.userHasPosted;

  return isfirstSeenAtInLastMonth && !hasCheckInBeenPublished;
};
